
import React from "react";
import { useForm } from 'react-hook-form';
import RFG from "../../libs/inputs/RFG";
import { Box, Typography, Button, Grid, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Stack } from "@mui/material";
import { BsPlusCircle, BsLayersFill } from "react-icons/bs";
import ImageEditor from "../../libs/imgcrop/ImageEditor";
import ImageResizer from "../extra/ImageResizer";
import CountrySelect from "../extra/CountrySelect";
import { localCountryCode } from "../../libs/Libs";
import { useDispatch } from "react-redux";
import { CATEGORYALL } from "../../services/actions";
import { FormHeroHeader, FormSectionCard, FormFooter, labelStyle } from "../extra/FormLayout";
import { generateFakeServiceData } from "../../libs/testDataGenerator";

export default function Form({
    title,
    companies = [],
    categories = [],
    defaultValues = {},
    onSubmit = (data) => { },
    onChange = (column, data) => { },
    back = () => { } }) {
    //let country = defaultValues?.country ? defaultValues.country : localCountryCode()
    const [open, setOpen] = React.useState(false)
    const [addCatOpen, setAddCatOpen] = React.useState(false)
    const [newCatName, setNewCatName] = React.useState("")
    const dispatch = useDispatch()

    const { handleSubmit, control, setValue, watch, clearErrors, setError, formState: { errors }, } = useForm({ defaultValues: defaultValues, mode: "all" })

    const handleAddCategory = async () => {
        if (!newCatName) return;
        try {
            const token = JSON.parse(localStorage.getItem("auth"))?.token;
            const res = await fetch(process.env.REACT_APP_URL + "category/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + token
                },
                body: JSON.stringify({ name: newCatName })
            });
            if (res.ok) {
                const data = await res.json();
                dispatch({ type: `${CATEGORYALL}_GET`, payload: 'category/' });
                setValue("category", data.id);
                setAddCatOpen(false);
                setNewCatName("");
            } else {
                alert("Failed to create category. It might already exist.");
            }
        } catch (e) {
            console.error(e);
        }
    };

    const handleFillFakeData = () => {
        const fakeData = generateFakeServiceData(categories);
        Object.entries(fakeData).forEach(([key, value]) => {
            setValue(key, value, { shouldValidate: true });
        });
        clearErrors();
    };

    const showAutoFill = process.env.REACT_APP_DEBUG !== "false" && process.env.REACT_APP_DEBUG !== "False" && process.env.REACT_APP_DEBUG !== "0";

    return (
        <>
            <Dialog open={addCatOpen} onClose={() => setAddCatOpen(false)} PaperProps={{ sx: { borderRadius: '16px', p: 1.5, minWidth: { xs: '90%', sm: '420px' } } }}>
                <DialogTitle sx={{ pb: 1, fontWeight: 700, fontSize: '18px', color: '#0f172a' }}>Add New Category</DialogTitle>
                <DialogContent sx={{ pt: '12px !important', pb: 2 }}>
                    <label className="input-label" style={labelStyle}>Category Name *</label>
                    <div className="mb-3" style={{ marginTop: '4px' }}>
                        <input
                            autoFocus
                            type="text"
                            placeholder="e.g. Audit & Assurance"
                            value={newCatName}
                            onChange={e => setNewCatName(e.target.value)}
                            style={{ width: '100%' }}
                        />
                    </div>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, pt: 1, gap: 1 }}>
                    <Button onClick={() => setAddCatOpen(false)} sx={{ textTransform: 'none', fontWeight: 600, color: '#64748b' }}>Cancel</Button>
                    <Button onClick={handleAddCategory} variant="contained" sx={{ textTransform: 'none', fontWeight: 600, borderRadius: '8px', px: 3, bgcolor: '#2563eb', '&:hover': { bgcolor: '#1d4ed8' } }}>Add</Button>
                </DialogActions>
            </Dialog>
            <Box sx={{ py: 3, px: { xs: 1, md: 3 }, maxWidth: '1400px', mx: 'auto' }}>
                <FormHeroHeader
                    icon={<BsLayersFill size={26} />}
                    title={title || "Service Catalog Setup"}
                    subtitle="Configure service name, category mapping, fee structures, and turnaround times (TAT)."
                    badgeText="Service Template"
                />
                <Box display="flex" justifyContent="flex-end" mb={2.5}>
                    {showAutoFill && (
                        <Button
                            data-testid="btn-auto-fill-fake-service"
                            type="button"
                            variant="outlined"
                            onClick={handleFillFakeData}
                            sx={{
                                borderColor: '#10b981',
                                color: '#059669',
                                bgcolor: '#ecfdf5',
                                textTransform: 'none',
                                fontWeight: 700,
                                fontSize: '13px',
                                borderRadius: '20px',
                                px: 2.5, py: 0.8,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                boxShadow: '0 2px 6px rgba(16, 185, 129, 0.15)',
                                '&:hover': { bgcolor: '#d1fae5', borderColor: '#059669', transform: 'translateY(-1px)' }
                            }}
                        >
                            ⚡ Auto-Fill Sample Data
                        </Button>
                    )}
                </Box>
                <form
                    onSubmit={handleSubmit((data) => {
                        console.log("data submit", data)
                        onSubmit(data)
                    })}>
                    <FormSectionCard
                        icon={<BsLayersFill size={20} />}
                        title="Service & Fee Configuration"
                        subtitle="Define category assignment, professional billing fees, and expected delivery SLAs"
                    >
                        <Grid container spacing={3}>
                            <Grid size={{ xs: 12, md: 6 }}>

                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box sx={{ flexGrow: 1 }}>
                                        <RFG name="category" label="Category *" control={control} labelStyle={labelStyle} rules={{ required: true }}>
                                            <select style={{ outline: 'none', boxShadow: 'none' }}>
                                                <option value="">Select Category</option>
                                                {categories.map((cat) => <option key={cat.id} value={cat.id}>{cat.name}</option>)}
                                            </select>
                                        </RFG>
                                    </Box>
                                    <IconButton disableRipple disableFocusRipple onClick={() => setAddCatOpen(true)} color="primary" sx={{ mt: 1.5, ml: 1, bgcolor: '#eff6ff', outline: 'none', boxShadow: 'none', '&:hover': { bgcolor: '#dbeafe' }, '&:focus, &:focus-visible': { outline: 'none', boxShadow: 'none' } }}>
                                        <BsPlusCircle size={18} />
                                    </IconButton>
                                </Box>
                                <RFG name="service_name" label="Service Name *" control={control} labelStyle={labelStyle} rules={{
                                    required: true,
                                    maxLength: {
                                        value: 100,
                                        message: `Cannot exceed 100 characters`,
                                    },

                                }}>
                                    <input autoComplete="false" placeholder="e.g. GST Annual Return Filing" />
                                </RFG>
                                <RFG name="professional_fee" label="Professional Fee *" control={control} labelStyle={labelStyle} rules={{
                                    required: true,
                                    pattern: {
                                        value: /^[0-9]+(\.[0-9]{1,2})?$/,
                                        message: "Enter a valid positive fee (e.g. 5000 or 1500.50)",
                                    },
                                    maxLength: {
                                        value: 12,
                                        message: `Cannot exceed 12 digits`,
                                    }
                                }}>
                                    <input type="number" step="any" autoComplete="false" placeholder="e.g. 5000" />
                                </RFG>

                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>

                                <RFG
                                    name="tat_days"
                                    label="TAT - in Days *"
                                    control={control}
                                    labelStyle={labelStyle}
                                    rules={{
                                        required: true,
                                        min: { value: 1, message: "TAT days must be at least 1" },
                                        max: { value: 365, message: "Cannot exceed 365 days" }
                                    }}
                                    onChange={(e) => { setValue("start_project_date", e.target.value) }}
                                >
                                    <input type="number" min="1" max="365" autoComplete="false" placeholder="e.g. 7" />
                                </RFG>

                                <RFG name="tat_hours" label="TAT - in Hours *" control={control} labelStyle={labelStyle} rules={{
                                    required: true,
                                    min: { value: 1, message: "TAT hours must be at least 1" },
                                    max: { value: 10000, message: "Cannot exceed 10000 hours" }
                                }}>
                                    <input type="number" min="1" max="10000" autoComplete="false" placeholder="e.g. 24" />
                                </RFG>
                                <RFG name="description" label="Description *" control={control} labelStyle={labelStyle} rules={{
                                    required: true,
                                    maxLength: {
                                        value: 400,
                                        message: `Cannot exceed 400 characters`,
                                    }
                                }}>
                                    <textarea autoComplete="false" placeholder="Provide detailed scope of work and service deliverables..." rows={3} maxLength={400} />
                                </RFG>

                            </Grid>
                        </Grid>
                    </FormSectionCard>

                    <Box display="flex" justifyContent="flex-end" sx={{ mt: 2, mb: 1 }}>
                        {showAutoFill && (
                            <Button
                                data-testid="btn-auto-fill-fake-bottom"
                                type="button"
                                variant="outlined"
                                onClick={handleFillFakeData}
                                sx={{
                                    borderColor: '#10b981',
                                    color: '#059669',
                                    bgcolor: '#ecfdf5',
                                    textTransform: 'none',
                                    fontWeight: 700,
                                    fontSize: '13px',
                                    borderRadius: '20px',
                                    px: 2.5, py: 0.8,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    boxShadow: '0 2px 6px rgba(16, 185, 129, 0.15)',
                                    '&:hover': { bgcolor: '#d1fae5', borderColor: '#059669', transform: 'translateY(-1px)' }
                                }}
                            >
                                ⚡ Auto-Fill Sample Data
                            </Button>
                        )}
                    </Box>

                    <FormFooter 
                        onCancel={back} 
                        backText="Back" 
                        submitText={defaultValues?.id ? "Update Service" : "Save Service"} 
                        isEdit={!!defaultValues?.id}
                        backTestId="back-service-btn" 
                        saveTestId="save-service-btn" 
                    />
                </form>
            </Box>
        </>
    );
}